import {useMemo} from 'react';
import {useSearchParams} from 'react-router';

import {searchParamLimits} from '@/config';
import {QueryParamsContext} from '@/modules/common/context/QueryParams/context';
import {parseQueryParams} from '@/modules/common/context/QueryParams/parseQueryParams';
import {schema} from '@/modules/common/context/QueryParams/schema';
import {getDefaultValues as getDefaultValuesImplementation} from '@/modules/common/context/QueryParams/utils/getDefaultValues';
import {useCurrentPage} from '@/modules/common/hooks/useCurrentPage';

type Props = React.PropsWithChildren;

export const QueryParamsProvider: React.FunctionComponent<Props> = ({
  children,
}) => {
  const [urlSearchParams] = useSearchParams();
  const currentPage = useCurrentPage();

  const queryParams = useMemo(
    () =>
      parseQueryParams({
        schema,
        urlSearchParams,
        getDefaultValues(travelType) {
          return getDefaultValuesImplementation({
            travelType,
            currentPage,
          });
        },
        limits: searchParamLimits,
      }),
    [urlSearchParams, currentPage]
  );

  return (
    <QueryParamsContext.Provider value={queryParams}>
      {children}
    </QueryParamsContext.Provider>
  );
};
